import Vue from 'vue'
export default new Vue;


// 描叙
/**
 *  1、setProjectName   设置面包屑导航（首页）+项目名称
 *  2、click            仅针对添加建筑页面：点击面包屑导航触发添加设备。
 *  3、collaspe         控制导航栏展开收起
 *  
 * 
 * 
 * 
 *  */